import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

import { primaryButtonStyle } from '../styles/buttonStyles'
import {
  footerModalActionsStyle,
  footerModalBoxStyle,
  footerModalOverlayStyle
} from '../styles/footerModalStyles'

const LicensesModal = ({ open, onClose, openedFrom }) => {
  const { t } = useTranslation()
  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)

  useEffect(() => {
    if (!open) return

    const handleKeyDown = e => {
      if (e.key === 'Escape') {
        if (openedFrom === 'checkbox') return
        onClose()
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onClose, openedFrom])

  if (!open) return null

  const licenses = t('licenses', {
    returnObjects: true
  })

  return (
    <>
      <div
        onClick={() => {
          if (openedFrom === 'checkbox') return
          onClose()
        }}
        style={footerModalOverlayStyle()}
      />

      <div style={footerModalBoxStyle()}>
        <div
          style={{
            marginBottom: 8,
            fontWeight: 'bold',
            fontSize: 24
          }}
        >
          {licenses.LICENSES_TITLE}
        </div>

        {licenses.LICENSES_INTRO && (
          <div
            style={{
              marginBottom: 12,
              fontSize: 17
            }}
          >
            {licenses.LICENSES_INTRO}
          </div>
        )}

        {Object.keys(licenses)
          .filter(
            key =>
              key.endsWith('_TITLE') &&
              key !== 'LICENSES_TITLE'
          )
          .map(key => {
            const base = key.replace('_TITLE', '')

            const descKey =
              licenses[`${base}_DESC`] !== undefined
                ? `${base}_DESC`
                : `${base}_INTRO`

            return (
              <div
                key={key}
                style={{
                  marginBottom: 12
                }}
              >
                <div
                  style={{
                    fontWeight: 'bold',
                    fontSize: 18
                  }}
                >
                  {licenses[key]}
                </div>

                {licenses[descKey] && (
                  <div
                    style={{
                      whiteSpace: 'pre-line',
                      fontSize: 16
                    }}
                  >
                    {licenses[descKey]}
                  </div>
                )}
              </div>
            )
          })}

        <div style={footerModalActionsStyle}>
          <button
            onClick={onClose}
            style={primaryButtonStyle(
              pressedBtn,
              'licenses-close',
              hoverBtn === 'licenses-close'
            )}
            onMouseEnter={() =>
              setHoverBtn('licenses-close')
            }
            onMouseLeave={() => {
              setHoverBtn(null)
              setPressedBtn(null)
            }}
            onMouseDown={() =>
              setPressedBtn('licenses-close')
            }
            onMouseUp={() => setPressedBtn(null)}
          >
            {openedFrom === 'checkbox'
              ? t('AGREE')
              : t('CLOSE')}
          </button>
        </div>
      </div>
    </>
  )
}

export default LicensesModal